(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
    const refundCheckbox = document.getElementById("refund_accept");
    const checkoutBtn = document.getElementById("checkout-btn");

    if (refundCheckbox && checkoutBtn) {
      function toggleCheckoutButton() {
        if (refundCheckbox.checked) {
          checkoutBtn.classList.remove("disabled");
          checkoutBtn.style.opacity = "1";
          checkoutBtn.style.pointerEvents = "auto";
        } else {
          checkoutBtn.classList.add("disabled");
          checkoutBtn.style.opacity = "0.5";
          checkoutBtn.style.pointerEvents = "none";
        }
      }

    
      toggleCheckoutButton();

      
      refundCheckbox.addEventListener("change", toggleCheckoutButton);
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-newsletter-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash === "#newsletter-thankyou") {
    const msg = document.getElementById("newsletter-thankyou");
    if (msg) {
      msg.style.display = "block";
      window.scrollTo({ top: msg.offsetTop - 150, behavior: "smooth" });
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
